module.exports = __webpack_public_path__ + "img/tiering-star-icon.0f86f9d3.svg";